export function getTokenPrefix(): string {
  return (import.meta as any).env.VITE_APP_OWL_CORE_TOKEN_PREFIX;
}
